import styled from 'styled-components';

export const ReactionsContainer = styled.div(({ theme: { size } }) => ({
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  minWidth: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  borderRadius: size.units(10),
  padding: `${size.units(1)} ${size.units(1)}`,
}));

export const ReactionsScrollArea = styled.div({
  display: 'flex',
  flex: 1, // fill remaining space between arrows
  minWidth: 0, // prevent flex child from overflowing container
  overflowX: 'auto',
  scrollbarWidth: 'none',
  '&::-webkit-scrollbar': {
    display: 'none',
  },
});

export const ArrowButton = styled.button(({ theme: { size, color, transition } }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: size.units(4),
  height: size.units(4),
  borderRadius: '50%',
  border: 'none',
  backgroundColor: 'transparent',
  color: color.content.reversed.default(),
  fontSize: size.units(2),
  cursor: 'pointer',
  WebkitTapHighlightColor: 'transparent',
  flexShrink: 0,
  transition: transition.standard('background'),
  userSelect: 'none',

  '&:hover': {
    backgroundColor: color.background.primary.hover(0.2),
  },
}));
